/**
 * Element-default contract — see §4.2 of the Advanced Theming v2 design.
 *
 * Maps an element-color-slot key to a palette token reference. Day 0 only
 * defines bespoke-extension *background* slots, all pointing at `primary.200`,
 * which gives every bespoke element a coherent themed default while the rest
 * of the override / picker UX is built out.
 */
import type { PaletteRef } from './types';

export const ELEMENT_DEFAULTS: {
	readonly 'callout.bg': PaletteRef;
	readonly 'cards.bg': PaletteRef;
	readonly 'carousel.bg': PaletteRef;
	readonly 'jsm-help.bg': PaletteRef;
	readonly 'section.bg': PaletteRef;
	readonly 'spotlight.bg': PaletteRef;
} = {
	// Bespoke extensions — backgrounds (day 0).
	'callout.bg': 'primary.200',
	'cards.bg': 'primary.200',
	'carousel.bg': 'primary.200',
	'spotlight.bg': 'primary.200',
	'jsm-help.bg': 'primary.200',
	// Sections use a lighter accent tint to differentiate from bespoke extension cards.
	'section.bg': 'accent.100',
};

export type ElementDefaultKey = keyof typeof ELEMENT_DEFAULTS;
